"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposalSiteUpdateInput = exports.DisposalSiteCreateInput = exports.DisposalSiteTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.DisposalSiteTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    public: typebox_1.Type.Boolean(),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    address: common_1.AddressTransport,
    coordinates: typebox_1.Type.Object({
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
    active: typebox_1.Type.Boolean(),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserId: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserId: typebox_1.Type.String(),
    }),
});
exports.DisposalSiteCreateInput = typebox_1.Type.Omit(exports.DisposalSiteTransport, [
    'id',
    'haulerID',
    'public',
    'metadata',
    'active',
]);
exports.DisposalSiteUpdateInput = typebox_1.Type.Partial(typebox_1.Type.Omit(exports.DisposalSiteTransport, ['id', 'haulerID', 'public', 'metadata']));
//# sourceMappingURL=disposal-site-transport.js.map